import React, {useEffect, useRef} from "react";
import LoadingBar from "react-top-loading-bar"; 
import { useLoad } from "../../context/Load";

export default function Load() {
  const {load, setLoad} = useLoad();

  const ref = useRef(null);

  useEffect(() => {
    if (load === true) {
      ref.current.continuousStart();
    }
    if (load === false) {
      ref.current.complete();
    }
  }, [load]);

  return (
    <>
      <LoadingBar color="#40f0ed" ref={ref} shadow={true} height={5} />
    </>
  );
}
